import { TypedUseSelectorHook, useSelector, useDispatch, useStore } from "react-redux";

import { AppAction, AppDispatch, RootState } from "state/store";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTypedDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTypedStore = () => useStore<RootState, AppAction>();
